/**
 * The pre-hook has exactly two exits: "Connect <App>" and "Not now". Outside clicks
 * and Escape must do nothing, so the dialog wires this one handler to
 * `onPointerDownOutside`, `onInteractOutside` and `onEscapeKeyDown` — the same
 * `e.preventDefault()` idiom `ChangePasswordDialog` / `AddOnConfigDialog` use.
 * The intent cookie is already spent by the time the modal renders, so an accidental
 * dismiss would leave the visitor on an empty Screens page with no way back to the app
 * they came for.
 *
 * It lives in its own module (rather than inline in the .tsx) so a unit test can
 * assert the behaviour directly. Radix's DismissableLayer escape handling is
 * layer-scoped and unreliable in jsdom, and the dialog's `open` is controlled by the
 * parent anyway, so a render-and-press-Escape test would pass whether or not the
 * handler were wired — it would prove nothing.
 */
export function preventImplicitDismiss(event: { preventDefault: () => void }): void {
  event.preventDefault();
}
